import { z } from 'zod';

export type DocumentEntityItem = z.infer<typeof documentEntityItemSchema>;
export type DocumentEntityItemCountSchema = z.infer<
  typeof documentEntityItemCountSchema
>;
export type DocumentSection = z.infer<typeof documentSectionSchema>;

export const documentEntityItemSchema = z.object({
  id: z.string(),
  last_update: z.string(),
  entity: z.string(),
  name: z.string(),
  year: z.number(),
  period: z.string(),
  release_date: z.string(),
  kind: z.string(),
  type: z.enum(['pdf', 'html', 'markdown']),
  source: z.string(),
  location: z.string(),
  indexed: z.boolean(),
  //TO DO: make required when api is updated
  reference: z.string().optional(),
});

export const documentSectionSchema = z.object({
  id: z.string(),
  created_at: z.string().datetime(),
  updated_at: z.string(),
  document: z.string(),
  content: z.string(),
  tags: z.object({
    page: z.string().nullish(),
  }),
});

export type EntityDocument = z.infer<typeof documentEntityItemSchema>;
export const documentEntityItemCountSchema = z.object({
  public: z.number(),
});

export const documentEntity = {
  getDocument: {
    path: (id: string) => `document/v1/${id}`,
    schema: documentEntityItemSchema,
  },
  getDocuments: {
    path: (entityTag: string) => `document/v1/entity/${entityTag}`,
    schema: z.array(documentEntityItemSchema),
  },
  getDocumentsCount: {
    path: (entityTag: string) => `document/v1/entity/${entityTag}/count`,
    schema: documentEntityItemCountSchema,
  },
  getDocumentContent: {
    path: (documentId: string) => `document/v1/${documentId}/content`,
  },
  getDocumentSection: {
    path: (sectionId: string) => `document/v1/section/${sectionId}`,
    schema: documentSectionSchema,
  },
};
